import {autoserializeAs} from "dcerialize";
import {ServerImage} from "../ServerImage";

export class ReferenceImages {
  @autoserializeAs(() => ServerImage)
  public readonly background?: ServerImage;
  @autoserializeAs(() => ServerImage)
  public readonly foreground?: ServerImage;
}
